module.exports = __webpack_public_path__ + "static/img/051.ff886d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/051.png
// module id = Z59t
// module chunks = 0